// YouTube helpers shared by the /app Tutorials modal and the admin playlists
// editor: pull the video id out of any of the URL shapes people paste
// (watch?v=, youtu.be, /embed/, /shorts/, /v/) and build the thumbnail URL
// YouTube serves for it.
export function youtubeId(url) {
  const s = String(url || "").trim();
  if (!s) return null;
  const m = s.match(/(?:embed\/|watch\?v=|youtu\.be\/|shorts\/|\/v\/|[?&]v=)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
}

// The URL an <iframe> can play. YouTube refuses to be framed from its
// watch?v=, youtu.be and /shorts/ pages, so any of those is turned into the
// /embed/ form; a link that isn't YouTube is passed through untouched.
export function youtubeEmbed(url) {
  const id = youtubeId(url);
  return id ? `https://www.youtube.com/embed/${id}?rel=0&playsinline=1` : String(url || "").trim();
}

export function youtubeThumb(url) {
  const id = youtubeId(url);
  return id ? `https://i.ytimg.com/vi/${id}/mqdefault.jpg` : null;
}

// A playlist's card image: the admin's own thumbnail when one is set,
// otherwise the first video's YouTube thumbnail.
export function categoryThumb(cat) {
  if (!cat) return null;
  if (cat.thumbnail) return cat.thumbnail;
  return youtubeThumb(((cat.videos || [])[0] || {}).youtubeUrl);
}
